import { Component } from '@angular/core';

@Component({
  selector: 'uni-form-field-verified',
  templateUrl: './uni-form-field-verified.component.html',
  styleUrls: ['./uni-form-field-verified.component.scss']
})
export class UniFormFieldVerifiedComponent {}
